import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { darkTheme } from './theme';
import { AppProvider, useApp } from './contexts';
import { QuizProvider } from './contexts';
import Layout from './components/Layout';
import Home from './pages/Home';
import Search from './pages/Search';
import Settings from './pages/Settings';
import CustomQuiz from './pages/CustomQuiz';
import QuizActive from './pages/QuizActive';
import Result from './pages/Result';
import About from './pages/About';
import DisclaimerDialog from './components/DisclaimerDialog';

function AppContent() {
  const { state, agreeDisclaimer } = useApp();
  const { agreedDisclaimer } = state;

  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <Layout>
        <Routes>
          <Route path="/" element={<Navigate to="/home" replace />} />
          <Route path="/home" element={<Home />} />
          <Route path="/custom" element={<CustomQuiz />} />
          <Route path="/search" element={<Search />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/quiz/active" element={<QuizActive />} />
          <Route path="/result" element={<Result />} />
          <Route path="/about" element={<About />} />
        </Routes>
      </Layout>
      <DisclaimerDialog open={!agreedDisclaimer} onAgree={agreeDisclaimer} />
    </ThemeProvider>
  );
}

export default function App() {
  return (
    <BrowserRouter basename="/">
      <AppProvider>
        <QuizProvider>
          <AppContent />
        </QuizProvider>
      </AppProvider>
    </BrowserRouter>
  );
}
